import React from 'react';
import { Clock3, PhoneCall, PhoneIncoming, PhoneMissed, PhoneOff, Timer } from 'lucide-react';
import { formatDuration } from '../callModel';

const ICONS = [PhoneCall, PhoneIncoming, PhoneMissed, PhoneOff, Timer, Clock3];
const TONES = ['purple', 'green', 'gold', 'red', 'blue', 'violet'];

/** The six figures across the top (this month), each opens the list filtered to it. */
export default function CallStats({ stats, onFilter }) {
  const s = stats;
  const rate = s && s.total_this_month ? Math.round((s.answered_this_month / s.total_this_month) * 100) : null;
  const rows = [
    ['Total Calls', s?.total_this_month, s ? `${s.inbound_this_month} in · ${s.outbound_this_month} out this month` : '', {}],
    ['Answered', s?.answered_this_month, rate == null ? 'This month' : `${rate}% of calls`, { status: 'answered' }],
    ['Missed', s?.missed_this_month, 'Including voicemail', { status: 'missed' }],
    ['Failed', s?.failed_this_month, 'Could not connect', { status: 'failed' }],
    ['Avg. Call Duration', s ? formatDuration(s.avg_duration_seconds) : null, 'Answered calls', null],
    ['Talk Time', s ? formatDuration(s.talk_time_seconds) : null, 'This month', null],
  ];
  return (
    <div className="cl-stats">
      {rows.map(([label, value, note, filter], i) => {
        const Icon = ICONS[i];
        const Tag = filter ? 'button' : 'div';
        return (
          <Tag key={label} className="cl-stat" {...(filter && { type: 'button', onClick: () => onFilter(filter), title: `Show ${label.toLowerCase()} calls` })}>
            <span className={`cl-stat-icon ${TONES[i]}`}><Icon size={19} /></span>
            <span><small>{label}</small><b>{value ?? '…'}</b><em>{note}</em></span>
          </Tag>
        );
      })}
    </div>
  );
}
